import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaAcertou = (): TabelaColuna => ({
  Chave: 'acertou',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 70 }}>Acertou</div>
})
